import { action } from 'satcheljs/lib/legacy';
import { getUnifiedGroupMembers } from 'owa-groups-services';
import { isSuccess, tryGetErrorFromBody } from 'owa-groups-services';
import { LogError, GroupsCommonErrorType } from 'owa-groups-logger';
import { GetUnifiedGroupMembersResult } from 'owa-groups-types';
import UnifiedGroupMembersResponse from 'owa-service/lib/contract/UnifiedGroupMembersResponse';
import { getUnifiedGroupMembersPromiseOverride } from 'owa-groups-adaptors';
import { getGroupsStore } from 'owa-groups-shared-store/lib/GroupsStore';
import addOrUpdateGroup from 'owa-groups-shared-store/lib/utils/addOrUpdateGroup';

const parseUnifiedGroupMembersResponse = (result: GetUnifiedGroupMembersResult) => {
    if (!result || !result.response || !result.response.Body || !isSuccess(result.response.Body)) {
        LogError(
            GroupsCommonErrorType.GetUnifiedGroupMembersError,
            'getUnifiedGroupMembersAction',
            'An error occurred while trying to retrieve group members.' +
                tryGetErrorFromBody(result.response)
        );
        return;
    }

    const groupMembers: UnifiedGroupMembersResponse = result.response.Body.MembersInfo;
    if (!groupMembers) {
        LogError(
            GroupsCommonErrorType.GetUnifiedGroupMembersError,
            'getUnifiedGroupMembersAction',
            'No group members were returned by the server'
        );
        return;
    }

    addOrUpdateGroup(getGroupsStore(), result.groupId, {
        basicInformation: null /*Not available at this point.*/,
        groupDetails: null /*Not available at this point*/,
        members: {
            membersArray: groupMembers.Members,
            totalCount: groupMembers.TotalCount,
        },
    });
};

const getGroupMembersAction = action('getGroupMembersAction')(
    (groupSmtpAddress: string, maxMembersToReturn?: number) => {
        const getter = getUnifiedGroupMembersPromiseOverride || getUnifiedGroupMembers;

        getter(groupSmtpAddress, maxMembersToReturn)
            .then(result => parseUnifiedGroupMembersResponse(result))
            .catch(e => {
                const context = getUnifiedGroupMembersPromiseOverride
                    ? 'getUnifiedGroupMembersPromiseOverride'
                    : 'getUnifiedGroupMembers';
                LogError(
                    GroupsCommonErrorType.GetUnifiedGroupMembersError,
                    context,
                    `An error occurred while trying to retrieve group members: ${e}.`
                );
            });
    }
);

export default getGroupMembersAction;
